import type { IPageAnalyticMapping } from '../../modules/analytic/types';

import { usePageAnalyticDetailContext } from '../../contexts/PageAnalyticDetailProvider';
import { PACardLineChart } from '../../modules/analytic';
import { useAnalyticData } from '~/core/gemxql/hooks';
import { EMetricKey } from '~/types/metric';
import { Grid } from '@shopify/polaris';

const ANALYTICS_DATA_SECOND: IPageAnalyticMapping[] = [
  { key: EMetricKey.ADDED_TO_CART, title: 'Add to cart' },
  { key: EMetricKey.ADD_TO_CART_RATE, title: 'Add to cart rate' },
  { key: EMetricKey.ORDERS, title: 'Orders' },
];
export const PageAnalyticGridLineFinal = () => {
  const { totalsRow, comparisonTotalsRow, columnTypes, isLoading } = usePageAnalyticDetailContext();
  const { computeMetric } = useAnalyticData();

  return (
    <Grid gap={{ xs: '200' }}>
      {ANALYTICS_DATA_SECOND.map(({ key, title }) => (
        <Grid.Cell
          key={key}
          columnSpan={{
            xs: 6,
            lg: 4,
          }}
        >
          <PACardLineChart
            title={title}
            metricKey={key}
            control={computeMetric({
              metric: totalsRow,
              previousMetric: comparisonTotalsRow,
              metricKey: key,
              formatter: columnTypes?.[key],
            })}
            isLoading={isLoading}
          />
        </Grid.Cell>
      ))}
    </Grid>
  );
};
